import "./bulkRequestPreview.scss";
import { Card, Flex, Result, Tabs } from "antd";
import { ChatBubble } from "molecules/ChatBubble";
import { EmptySpin } from "molecules/ui/EmptySpin/EmptySpin";
import { getApiException } from "api/exceptions";
import { useGetProviderPreviewPaymentRequest } from "api/clients/useGetProviderPreviewPaymentRequest";

export const BulkRequestPreview = () => {
    const { isPending, error, data } = useGetProviderPreviewPaymentRequest();

    return (
        <Flex vertical={true} gap={8}>
            <strong>Preview</strong>
            <Card className="vyne-bulk-request-confirm-modal-preview">
                <Tabs
                    items={[
                        {
                            key: "SMS-Preview",
                            label: "SMS",
                            children: <SMSPreview data={data?.smsTemplate} isPending={isPending} error={error} />,
                        },
                        {
                            key: "Email-Preview",
                            label: "Email",
                            children: <EmailPreview data={data?.emailTemplate} isPending={isPending} error={error} />,
                        },
                    ]}
                    animated={{ inkBar: false, tabPane: false }}
                    // This stops from akward resizing of the tabs when switching between them.
                    destroyOnHidden={true}
                />
            </Card>
        </Flex>
    );
};

interface PreviewProps {
    readonly data: string | undefined;
    readonly isPending: boolean;
    readonly error: Error | null;
}

const SMSPreview = ({ data, isPending, error }: PreviewProps) => {
    if (isPending) {
        return <EmptySpin tip="Getting your sample Bulk Request SMS template..." />;
    }

    if (error || data === undefined) {
        const { detail } = getApiException(error, "Sorry, something went wrong getting your SMS template");
        return <Result status="error" title={detail} subTitle="Please try again later." />;
    }

    return <ChatBubble text={data} type="send" maxWidth={true} />;
};

const EmailPreview = ({ data, isPending, error }: PreviewProps) => {
    if (isPending) {
        return <EmptySpin tip="Getting your sample Bulk Request email template..." />;
    }

    if (error || data === undefined) {
        const { detail } = getApiException(error, "Sorry, something went wrong getting your email template");
        return <Result status="error" title={detail} subTitle="Please try again later." />;
    }

    return (
        <iframe
            id="iframe-email-preview"
            title="Payments Email Request Preview"
            name="Payments Email Request Preview"
            sandbox="allow-scripts"
            srcDoc={data}
        />
    );
};
